// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__71xI9","checkmark":"Checkbox_checkmark__H3nN5","primary":"Checkbox_primary__8ieTw","secondary":"Checkbox_secondary__0g2id"};